import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur-md shadow-sm"
            : "bg-transparent"
        }`}
      >
        <nav className="flex items-center justify-between px-4 md:px-8 py-4">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
            aria-label="黑料吃瓜网首页"
          >
            <span
              className={`text-xl md:text-2xl font-bold font-heading tracking-tight transition-colors ${
                scrolled ? "text-foreground-950" : "text-white"
              }`}
            >
              黑料吃瓜网
            </span>
            <span
              className={`hidden md:inline-block text-[10px] px-2 py-0.5 rounded-full font-medium transition-colors ${
                scrolled
                  ? "bg-primary-500 text-white"
                  : "bg-white/20 text-white"
              }`}
            >
              独家爆料
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            type="button"
            className={`md:hidden p-2 rounded-md transition-colors ${
              scrolled
                ? "text-foreground-700 hover:bg-background-100"
                : "text-white hover:bg-white/10"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换导航菜单"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </nav>
      </header>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-foreground-950/95 backdrop-blur-md pt-20 px-6 md:hidden">
          <div className="flex flex-col gap-2">
            <Link
              to="/"
              className="text-white text-lg font-medium py-3 border-b border-white/10"
              onClick={() => setMobileOpen(false)}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="text-white text-lg font-medium py-3 border-b border-white/10"
                onClick={() => setMobileOpen(false)}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-white text-lg font-medium py-3 border-b border-white/10"
              onClick={() => setMobileOpen(false)}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </>
  );
}